import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-layout-document-list",
    templateUrl: "./layout-document-list.component.html",
    styleUrls: ["./layout-document-list.component.scss"],
})
export class LayoutDocumentListComponent implements OnInit {
    @Input() inputData: any;

    constructor() {}

    ngOnInit() {}

    getDate(item: any): any {
        return item?.CreatedDate || item?.createdDate || item?.PublishDate || item?.publishDate || item?.Date || item?.date || this.inputData?.CreatedDate || null;
    }
}
